import AppVersionSwitch from './AppVersionSwitch';

export default AppVersionSwitch;
